require('./bootstrap');

import { createApp } from 'vue';
// import { ZiggyVue } from 'ziggy';
// import { Ziggy } from './ziggy';
import Lang from 'lang.js';
import messages from './messages.json';
import Notifications from '@kyvg/vue3-notification';

/*
 * COMPONENT IMPORTS
 */
import GlobalComponent from './components/GlobalComponent';
import ImageVerification from './components/ImageVerification/ImageVerification.vue';
import DialogStatus from './components/Status/DialogStatus.vue';

const app = createApp({
  mounted() {
    console.log('mounted');
  }
});


const default_locale = window.default_locale;
const fallback_locale = window.fallback_locale;
app.config.globalProperties.trans = new Lang({
  messages,
  locale: default_locale,
  fallback: fallback_locale
});

/*
 * USE
 */
// app.use(ZiggyVue, Ziggy);
app.use(Notifications);

/*
 * COMPONENTS
 */
app.component('global-component', GlobalComponent);
app.component('image-verification', ImageVerification);
app.component('dialog-status', DialogStatus);

/*
 * MOUNT
 */
app.mount('#app');

